var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIviSignLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 999.9884033",
    enableBackground: "new 0 0 1000 999.9884033",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1193.0072021,
    y1: -535.4187012,
    x2: 96.7977829,
    y2: 1104.276001,
    gradientTransform: "matrix(1 0 0 -1 0 1001.1542358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.798146,
    style: {
      stopColor: "#F30745"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976597,
    style: {
      stopColor: "#FFBCCE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M988.0872192,555.9534912c-46.1080933,401.9429321-142.1335449,478.2290039-544.076416,432.1209106 c-401.9444885-46.104126-478.1899414-142.133667-432.102417-544.0765381 C58.0144958,42.0554047,154.041214-34.1900864,555.9824829,11.9163017 C957.9093018,57.9851532,1034.1914062,154.0114746,988.0872192,555.9534912z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078016299408180080960000017762289803553521339_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.3326721,
    y1: 503.3755493,
    x2: 283.393219,
    y2: 528.1140137,
    gradientTransform: "matrix(1 0 0 -1 0 1001.1542358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000078016299408180080960000017762289803553521339_)",
    d: "M667.5496216,266.6128235 c-40.5524292,0-72.989502,16.2285461-105.4506836,63.9801636L435.9355774,520.7565918l11.7242737-147.7975159 c3.605011-55.8836975-31.5438538-106.3462524-93.7303467-106.3462524c-57.6777649,0-93.7250977,38.7583008-97.3337097,88.3252258 l-19.8187561,272.1663818c-4.5058746,67.5900269,30.6441956,106.3479004,86.5098877,106.3479004 s91.0145569-40.5523682,117.1549072-77.4997559L562.098938,471.211731l-10.8029785,155.9127197 c-5.4035034,63.0837402,28.828064,106.3479004,91.0145874,106.3479004c57.6801758,0,95.520813-34.2516479,99.1297607-85.6150513 l19.8195801-274.8781738c4.5062866-54.071167-21.6340942-106.3478699-93.7263184-106.3478699L667.5496216,266.6128235z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115474551817652254960000004500345905647584916_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.7595825,
    y1: 269.8112183,
    x2: 359.6523132,
    y2: 558.2642822,
    gradientTransform: "matrix(1 0 0 -1 0 1001.1542358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000115474551817652254960000004500345905647584916_)",
    d: "M447.6598511,372.9150391l-11.7242737,147.7974854 l4.5062561,135.1959839c-26.1403503,36.9433594-61.2892151,77.4957886-117.1549072,77.4957886 s-91.0157623-38.7579346-86.5098877-106.3439331l19.8187561-272.1703796 c3.6086121-49.5653076,39.6559448-88.3236084,97.3337097-88.3236084 C416.1159973,266.5663757,451.2648621,317.0289307,447.6598511,372.9150391z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M447.828064,365.2763977c0-51.5664673-33.3383179-98.6635742-94.6275635-98.6635742 c-61.2864075,0-96.8474426,45.9567261-96.8474426,95.5232239c0,53.1739502,39.8986816,94.6235657,95.7659607,94.6235657 c55.8656616,0,95.7090454-38.3292847,95.7090454-91.5032349V365.2763977z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIviSignLogo);
export default __webpack_public_path__ + "static/media/ivi-sign-logo.1d82290ae4e732519f5c8e5a98112b7d.svg";
export { ForwardRef as ReactComponent };